{
  "title": "Working notes",
  "description": "Private, unverified context for your own investigations.",
  "privacyNotice": "Working notes are visible only to the agent that wrote them. They are not evidence, not reviewed lessons, and never become memory without a proposal and a person's review.",
  "list": {
    "heading": "Your investigations",
    "context": "Owner-only · metadata only",
    "count": "{{count}} private note",
    "count_plural": "{{count}} private notes",
    "openToInspect": "Open to inspect",
    "privateNote": "Private note",
    "version": "v{{version}}",
    "emptyTitle": "No private notes yet",
    "emptyMessage": "Working notes are short-lived investigation context owned by your agent. Start with a service, environment, and investigation ID.",
    "errorTitle": "Working notes unavailable",
    "refresh": "Refresh"
  },
  "scopeForm": {
    "legend": "Open a working note",
    "service": "Service",
    "environment": "Environment",
    "investigationId": "Investigation ID",
    "open": "Open note",
    "bytes": "{{field}} must be no more than {{limit}} UTF-8 bytes."
  },
  "detail": {
    "emptyTitle": "Inspect a private note",
    "emptyMessage": "Choose one of your notes, or enter its service, environment, and investigation ID.",
    "notFoundTitle": "No note for this investigation",
    "notFoundMessage": "There is no owner-authored working note in this scope. Its absence does not affect the durable memory or review queue. Start one below.",
    "purgedTitle": "This note was purged",
    "purgedMessage": "Every saved version was erased. A new checkpoint starts from version {{version}}.",
    "errorTitle": "Working note unavailable",
    "privateWorkingNote": "Private working note",
    "unverified": "Unverified agent-authored",
    "updated": "Updated",
    "checkpoint": "Checkpoint",
    "snapshot": "Snapshot",
    "noSnapshot": "None",
    "privateLine": "Visible only to this owning agent. This working text is private context; it is not evidence, an approved lesson, or a memory eligible for promotion.",
    "goal": "Goal",
    "progress": "Progress",
    "hypotheses": "Hypotheses",
    "openQuestions": "Open questions",
    "nextActions": "Next actions",
    "blockers": "Blockers",
    "nothingRecorded": "Nothing recorded yet.",
    "noBlockers": "No blockers recorded.",
    "hiddenTitle": "Saved text withheld",
    "hiddenMessage": "The current checkpoint does not allow showing its note body. No earlier text is displayed. Start a new explicit checkpoint from a fresh snapshot to continue.",
    "contextChangedTitle": "Historical note · context changed",
    "contextChangedMessage": "This saved text remains visible as historical context. Save an explicit checkpoint for the changed architecture before archiving it.",
    "needsRefreshTitle": "Historical note · refresh required",
    "needsRefreshMessage": "This saved text remains visible as historical context. Archiving will obtain a fresh snapshot for this investigation before saving the reviewed note version.",
    "back": "Back to notes",
    "view": "Saved note",
    "edit": "Edit note"
  },
  "editor": {
    "heading": "Append a checkpoint",
    "newHeading": "Start a note",
    "hint": "Saving appends a new version; earlier versions are kept. One item per line.",
    "goal": "Goal",
    "goalPlaceholder": "What this investigation is trying to establish",
    "status": "Status",
    "progress": "Progress",
    "hypotheses": "Hypotheses",
    "openQuestions": "Open questions",
    "nextActions": "Next actions",
    "blockers": "Blockers",
    "blockerKind": "Kind",
    "blockerReason": "Reason",
    "addBlocker": "Add blocker",
    "removeBlocker": "Remove blocker",
    "save": "Save version {{version}}",
    "cancel": "Discard changes",
    "goalRequired": "A goal is required.",
    "tooManyItems": "{{field}} can hold at most {{max}} items.",
    "itemTooLong": "Each {{field}} item must be 500 characters or fewer."
  },
  "statusOptions": {
    "active": "Active",
    "paused": "Paused",
    "completed": "Completed",
    "archived": "Archived"
  },
  "blockerKinds": {
    "needs_approval": "Needs approval",
    "needs_access": "Needs access",
    "needs_evidence": "Needs evidence",
    "needs_human": "Needs a person",
    "waiting_dependency": "Waiting on a dependency"
  },
  "actions": {
    "heading": "Actions",
    "archive": "Archive note",
    "archiveHint": "Archiving closes this private checkpoint. It does not promote or publish the note.",
    "archiveConfirmTitle": "Archive the working note for {{investigation}}?",
    "archiveConfirmBody": "This closes the private checkpoint. It does not publish anything.",
    "archiveConfirmOk": "Yes, archive",
    "archived": "Working note archived.",
    "purge": "Purge all versions",
    "purgeHint": "Erases every saved version of this note and leaves a tombstone. Copies elsewhere cannot be retracted.",
    "purgeConfirmTitle": "Purge every version of the note for {{investigation}}?",
    "purgeConfirmBody": "All agent-authored text for this investigation is erased, including archived versions. This cannot be undone.",
    "purgeConfirmOk": "Yes, purge",
    "purged": "Purged {{count}} version.",
    "purged_plural": "Purged {{count}} versions.",
    "nothingPurged": "Nothing to purge.",
    "pin": "Pin a snapshot",
    "pinHint": "Pins a fresh snapshot of memory for this investigation and returns its ID.",
    "pinned": "Snapshot pinned.",
    "snapshotId": "Snapshot ID"
  },
  "notices": {
    "savedTitle": "Checkpoint saved",
    "saved": "Version {{version}} is now the current note.",
    "archivedTitle": "Note archived",
    "changedTitle": "Note changed",
    "versionConflict": "A newer checkpoint replaced the version you reviewed. Inspect the current note and confirm again.",
    "snapshotRefresh": "The snapshot changed before the note could be saved. Inspect the refreshed note and confirm again.",
    "snapshotMissing": "A fresh checkpoint could not be prepared. Refresh the note before trying again.",
    "offlineTitle": "You are offline",
    "offline": "Reconnect and refresh to load owner-scoped notes. Changes cannot be saved until then.",
    "unreachable": "The memory service could not be reached. Refresh after reconnecting."
  },
  "errors": {
    "list": "Could not load your working notes.",
    "detail": "Could not load the working note.",
    "save": "Could not save the checkpoint.",
    "archive": "Could not archive the note.",
    "purge": "Could not purge the note.",
    "pin": "Could not pin a snapshot."
  }
}
